import { render, staticRenderFns } from "./DefaultTagInput.vue?vue&type=template&id=c853fd06&"
import script from "./DefaultTagInput.vue?vue&type=script&lang=js&"
export * from "./DefaultTagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports